import isEmpty from 'lodash/isEmpty';
import React, { useMemo } from 'react';
import { Media } from '@honda-canada/design-system-react';
import BrandNavigation from './BrandNavigation';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import { ACURA_SITE_NAME } from '../../utils/constants';
import { createObjectFromProps } from '../../utils/object';
import { useAppName } from '../../utils/sitecoreContext';
var BrandNavigationMap = function (_a) {
    var propVariant = _a.variant, fields = _a.fields, _b = _a.rendering, rendering = _b === void 0 ? { componentName: 'BrandNavigation' } : _b;
    var appName = useAppName();
    var skip = false;
    var variant;
    var mappedFields = fields;
    switch (appName) {
        case ACURA_SITE_NAME:
            skip = true;
            break;
        default:
            break;
    }
    var appNameConfig = useMemo(function () { return ({ variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant }); }, [propVariant, variant]);
    mappedFields = useMemo(function () { return createObjectFromProps(mappedFields); }, [safelyStringifyJSON(mappedFields)]);
    if (skip || !mappedFields || isEmpty(mappedFields) || isEmpty(mappedFields.items)) {
        return null;
    }
    return (React.createElement(Media, { greaterThanOrEqual: "desktop" },
        React.createElement(BrandNavigation, { appNameConfig: appNameConfig, componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, fields: mappedFields })));
};
export default BrandNavigationMap;
